export default __webpack_public_path__ + "static/media/ic_bg_user.1164d411.svg";